import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let router = new Router({
  routes: [{
      path: '/',
      name: 'home',
      redirect: {
        name: 'dashboard'
      }
    }, {
      path: '/login',
      name: 'login',
      component: () => import('../views/Login.vue'),
      meta: {
        guest: true,
        layout: 'no-navbar'
      }
    },
    {
      path: '/map',
      name: 'map',
      component: () => import('../views/MapView.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/list',
      name: 'list',
      component: () => import('../views/ListView.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('../views/Dashboard.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: () => import('../views/Maintenance.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/erms',
      name: 'erms',
      component: () => import('../views/Erms.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/print/:id',
      name: 'print',
      component: () => import('../views/Print.vue'),
      meta: {
        layout: 'no-navbar'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('token') == null) {
      next({
        path: '/login',
        query: {
          nextUrl: to.fullPath
        }
      })
    } else {
      let user = JSON.parse(localStorage.getItem('user'))
      if (to.matched.some(record => record.meta.is_admin)) {
        if (user.role == 'superuser' || user.role == 'admin') {
          next()
        } else {
          next({
            name: 'home'
          })
        }
      } else {
        next()
      }
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (localStorage.getItem('token') == null) {
      next()
    } else {
      next({
        name: 'home'
      })
    }
  } else {
    next()
  }
})

export default router